import axios from "axios"

async function getServiceWorkerVersion() {
  const res = await axios({
    url: `/version.json?&timestamp=${new Date().getTime()}`, //your url
    method: 'GET',
    responseType: 'json',
    headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  })
  return res.data
}

export async function checkServiceWorkerVersion() {
  const requiredVersion = await getServiceWorkerVersion()
  const currentVersion = {
    version: import.meta.env.VUE_APP_VERSION,
    buildId: import.meta.env.VUE_APP_BUILD_ID,
  }

  if (!requiredVersion.version || !requiredVersion.buildId) {
    return false
  }

  if (
    requiredVersion.version !== currentVersion.version
    || requiredVersion.buildId !== currentVersion.buildId
  ) {
    return false
    // await store.dispatch('app/setIsNewVersionAvailable', true)
  }
  return true
}

async function clearWorkboxCaches() {
  if (!('caches' in window)) {
    return
  }
  const cacheNames = await caches.keys()
  await Promise.all(
    cacheNames
      .filter((cacheName) => (
        cacheName.startsWith('workbox-')
        || cacheName.includes('-precache-')
        || cacheName.includes('-runtime-')
      ))
      .map((cacheName) => caches.delete(cacheName))
  )
}

export async function cleanupDevelopmentServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return
  }

  const cleanupKey = 'development-service-worker-cleaned'
  if (sessionStorage.getItem(cleanupKey)) {
    return
  }

  const registrations = await navigator.serviceWorker.getRegistrations()
  const cacheNames = 'caches' in window ? await caches.keys() : []
  const hasWorkboxCaches = cacheNames.some((cacheName) => (
    cacheName.startsWith('workbox-')
    || cacheName.includes('-precache-')
    || cacheName.includes('-runtime-')
  ))

  if (!registrations.length && !hasWorkboxCaches) {
    sessionStorage.setItem(cleanupKey, '1')
    return
  }

  sessionStorage.setItem(cleanupKey, '1')
  await Promise.all(registrations.map((registration) => registration.unregister()))
  await clearWorkboxCaches()
  window.location.reload()
}

export async function refreshServiceWorker() {
  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      }
      if (registration.active) {
        registration.active.postMessage({ type: 'SKIP_WAITING' })
      }
      await registration.unregister();
    }
    await clearWorkboxCaches()
  } catch (e) {
    console.log('e', e)
  } finally {
    window.location.reload()
  }
}
